// extracted by mini-css-extract-plugin
module.exports = {"detailDrawer":"detailDrawer_detailDrawer__371Tw","drawerHeader":"detailDrawer_drawerHeader__1Y274","drawerAction":"detailDrawer_drawerAction__2a1PY"};